import { render, staticRenderFns } from "./SelectRemote.vue?vue&type=template&id=364e70b1&"
import script from "./SelectRemote.vue?vue&type=script&lang=js&"
export * from "./SelectRemote.vue?vue&type=script&lang=js&"
import style0 from "./SelectRemote.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports